import React from 'react';
import { Card, Typography, CardMedia, Stack, TextField, Button, Box, useMediaQuery, useTheme } from '@mui/material';

// Import your images
import Founder1 from '../../../assets/Landing/contactus.png'; 
import Founder2 from '../../../assets/Landing/fu1.png'; 

export default function FoundersCard() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Card
      sx={{
        width: '100%',
        height: isMobile ? 'auto' : '120vh',
        backgroundColor: '#1C486A',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 4,
      }}
    >
      {/* Heading inside the card */}
      <Typography
        variant={isMobile ? 'h4' : 'h2'}
        textAlign="center"
        sx={{
          fontWeight: 'bold',
          color: '#f1f1f1',
          marginBottom: 4,
        }}
      >
        Book A {' '} 
        <span
          style={{
            color: 'transparent',
            WebkitTextStrokeWidth: '1px',
            WebkitTextStrokeColor: '#f1f1f1',
          }}
        >
          Consultation <br/>
        </span>
        With Us!
      </Typography>

      {/* Main card structure (image + form) */}
      <Stack
        direction="column"
        spacing={isMobile ? 2 : 4}
        sx={{ width: '100%', justifyContent: 'space-between', alignItems: 'center' }}
      >
        {/* Right: Contact Form */}
        <Card
          sx={{
            width: isMobile ? '100%' : '40%',
            height: isMobile ? 'auto' : '80vh',
            background: '#fff',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderRadius: '20px',
            padding: 3,
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
            order: isMobile ? 1 : 'unset',
          }}
        >
          {/* Form inside the card */}
          <Box
            component="form"
            sx={{
              width: '100%',
              padding: 2,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            {/* Input fields */}
            <TextField
              label="Name"
              variant="outlined"
              fullWidth
              required
              sx={{ marginBottom: 2 }}
            />
            <TextField
              label="Email"
              variant="outlined"
              fullWidth
              required
              sx={{ marginBottom: 2 }}
            />
            <TextField
              label="Phone"
              variant="outlined"
              fullWidth
              sx={{ marginBottom: 2 }}
            />
            <TextField
              label="Message"
              variant="outlined"
              fullWidth
              multiline
              rows={4}
              sx={{ marginBottom: 2 }}
            />

            {/* Submit button */}
            <Button
              variant="outlined"
              fullWidth
              sx={{
                borderColor: '#1C486A',
                color: '#1C486A',
                marginTop: 2,
                '&:hover': {
                  backgroundColor: '#1C486A',
                  color: '#fff',
                },
              }}
            >
              Submit
            </Button>
          </Box>
        </Card>

        {/* Left: Contact Us Image */}
        <Card
          sx={{
            width: isMobile ? '100%' : '40%',
            height: isMobile ? 'auto' : '80vh',
            background: '#1C486A',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '20px',
            padding: 3,
            order: isMobile ? 2 : 'unset',
          }}
        >
          <CardMedia component="img" src={Founder1} alt="Contact Us" sx={{ width: '100%', borderRadius: '20px' }} />
        </Card>

        {/* Vertical "FOUNDERS" Text (hidden on mobile) */}
        {!isMobile && (
          <Stack justifyContent="center" alignItems="center" sx={{ height: '70vh' }}>
            <Typography
              variant="h3"
              sx={{
                color: 'transparent',
                fontWeight: 'bold',
                writingMode: 'vertical-rl',
                textOrientation: 'upright',
                WebkitTextStroke: '2px #1C486A',
              }}
            >
              FOUNDERS
            </Typography>
          </Stack>
        )}
      </Stack>
    </Card>
  );
}
